import React, { useState, useEffect, useRef } from 'react';
import { FiTarget, FiEye } from 'react-icons/fi';
import './About.css';
import ImprovedHeroSection from './ImprovedHeroSection';
import AboutBentley from './AboutBentley';
import BentleyLogo from '../assets/Logos/bentleylogo.svg'
import AutoCADIsometricDrawingExercise from '../assets/videos/about/AutoCADIsometricDrawingExercise.mp4'
import { FiMapPin, FiAward, FiGlobe } from 'react-icons/fi';
import AboutOverview from './AboutOverview';

const About = () => {
  const [text, setText] = useState('');
  const sectionRef = useRef(null);
  const fullText =
    'Empowering engineers, students, and professionals with world-class training in Bentley infrastructure design and analysis software.';

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elementsToAnimate = sectionRef.current.querySelectorAll('.animate-on-scroll');
    elementsToAnimate.forEach(el => observer.observe(el));

    // Typewriter effect
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < fullText.length) {
        setText(fullText.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
        const cursor = document.querySelector('.cursor');
        if (cursor) cursor.style.animation = 'none';
      }
    }, 50);

    return () => {
      elementsToAnimate.forEach(el => observer.unobserve(el));
      clearInterval(typingInterval);
    };
  }, []);

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div className="about-content-section hero-partners-gap">
        <ImprovedHeroSection />
      </div>

      <div className="about-content-section">
        <AboutBentley
          videoSrc={AutoCADIsometricDrawingExercise}
          logoSrc={BentleyLogo}
          logoSmallSrc="https://brand.autodesk.com/wp-content/uploads/2025/02/adsk-brand-hub-logo-Logo-1-lockup.svg"
        />
      </div>
      <div className="about-content-section">
        <AboutOverview />
      </div>
    </section>
  );
};

export default About;